// extracted by mini-css-extract-plugin
export default {"OrderId":"OrderScreen_OrderId__cOBVn","Badge":"OrderScreen_Badge__jewS6","CustomerCard":"OrderScreen_CustomerCard__zYpvG","Date":"OrderScreen_Date__SGy22"};